import { motion } from "framer-motion";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
} from "@/components/ui/Table";
import React from "react";

export const markdownTableComponents = {
  table: ({ children }: any) => (
    <div className="my-4 w-full overflow-x-auto">
      <Table className="w-full">{children}</Table>
    </div>
  ),

  thead: ({ children }: any) => {
    const hasContent = React.Children.toArray(children).some((child: any) => {
      if (child?.props?.children && Array.isArray(child.props.children)) {
        return child.props.children.some(
          (th: any) =>
            th?.props?.children && th.props.children.toString().trim() !== ""
        );
      }
      return false;
    });
    return hasContent ? <TableHeader>{children}</TableHeader> : null;
  },

  tbody: ({ children }: any) => <TableBody>{children}</TableBody>,

  tr: ({ children }: any) => (
    <motion.tr
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="border-b border-border/50 hover:bg-muted/30 transition-colors data-[state=selected]:bg-muted"
    >
      {children}
    </motion.tr>
  ),

  th: ({ children }: any) => (
    <TableHead className="whitespace-nowrap font-bold h-10 px-4 text-left align-middle text-foreground">
      {children}
    </TableHead>
  ),

  td: ({ children }: any) => (
    <TableCell className="align-top p-4 break-words leading-relaxed">
      {children}
    </TableCell>
  ),
};
